var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeersonaWhite26(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4962 12.0049C11.8611 13.5362 10.3177 15.0799 8.78634 19.7145C8.66035 20.0955 8.12156 20.0955 7.99559 19.7145C6.46427 15.0796 4.92053 13.5362 0.285775 12.0049C-0.0952583 11.8789 -0.0952583 11.3401 0.285775 11.2141C4.92079 9.68287 6.46422 8.13916 7.99559 3.50452C8.12158 3.12349 8.66037 3.12349 8.78634 3.50452C10.3177 8.13942 11.8614 9.68282 16.4962 11.2141C16.8772 11.3401 16.8772 11.8789 16.4962 12.0049Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8575 4.39359C17.5406 5.15874 16.7683 5.93104 16.0021 8.24893C15.9396 8.43945 15.6702 8.43945 15.6067 8.24893C14.8416 5.93203 14.0692 5.15978 11.7513 4.39359C11.5608 4.33111 11.5608 4.06173 11.7513 3.99823C14.0682 3.23308 14.8405 2.46078 15.6067 0.142886C15.6692 -0.0476287 15.9386 -0.0476287 16.0021 0.142886C16.7673 2.45979 17.5396 3.23204 19.8575 3.99823C20.048 4.06071 20.048 4.33009 19.8575 4.39359Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeersonaWhite26);
export default __webpack_public_path__ + "static/media/peersona-white-26.7b2bcdbe036fd47d3e4db302a9b68f53.svg";
export { ForwardRef as ReactComponent };